import React, { useState } from "react";
import { If } from "react-condition";
import { useHistory, Link } from "react-router-dom";
import { useEffect } from "react";
import logo from "../images/Maxicus_logo.png";
import ChangePassword from "../pages/Authentication/ChangePassword";
import { Button, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
function NavbarUser() {
  const history = useHistory();
  const [loggedIn, setLoggedIn] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("candidate.token") !== null &&
      localStorage.getItem("candidate.name") !== null &&
      localStorage.getItem("candidate.email") !== null &&
      localStorage.getItem("candidate.id") !== null
    ) {
      setLoggedIn(true);
    }
  }, []);

  function onClickLogout(event) {
    event.preventDefault();
    localStorage.removeItem("candidate.name");
    localStorage.removeItem("candidate.token");
    localStorage.removeItem("candidate.email");
    localStorage.removeItem("candidate.id");
    history.push("/careers");
  }

  const items = [
    {
      key: "1",
      label: (
        <button className="dropdown-item" onClick={(e) => setOpen(true)}>
          <i className="fa fa-user fa-fw mr-2"></i>
          Change Password
        </button>
      ),
    },
    {
      key: "2",
      label: (
        <button className="dropdown-item" onClick={onClickLogout}>
          <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
          Logout
        </button>
      ),
    },
  ];

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 mt-0 static-top shadow">
      <div className="container-fluid">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link nav-link-black nav-link-bold nav-brand"
              href="/careers/home"
            >
              <img src={logo} alt="" />
            </a>
          </li>
          {/* <li className="nav-item">
            <Link className="nav-link" to="/careers/home" exact>
              <h6 className="mb-0">Profile</h6>
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/careers/home" exact>
              <h6 className="mb-0">Job Recommendations</h6>
            </Link>
          </li> */}
        </ul>
        <Dropdown
          className="mr-4"
          menu={{ items }}
          trigger={["click", "hover"]}
          arrow
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space className="flex items-center max-w-full">
              <i className="fa fa-user fa-fw"></i>
              <span
                className="truncate max-w-[60px] sm:max-w-[150px] md:max-w-[200px] inline-block align-middle"
                title={localStorage.getItem("candidate.name") || ""}
              >
                {localStorage.getItem("candidate.name") || ""}
              </span>
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
        {open && (
          <ChangePassword
            component="career"
            closeModal={setOpen}
            openModal={open}
          />
        )}
      </div>
    </nav>
  );
}

export default NavbarUser;
